export const PAGES = {
  LOADINGSCREEN: 'LoadingScreen',
  LOADINGAPP: 'LoadingApp',
  FREIGHTSCREEN: 'FreightScreen',
  FREIGHTAPP: 'FreightApp',
  DELIVERIESSCREEN: 'DeliveriesScreen',
  NUVOAPP: 'NuvoApp',
  MASTERSCREEN: 'MasterScreen',
  MASTERAPP: 'MasterApp',
  MASTERSTANDARDAPP : 'MasterStandardApp',
  AUTHENTICATION_TOKEN: 'AuthenticationToken',
  LOGIN: '/',
  CONTRACTSCREEN: 'ContractScreen',
  CONTRACTAPP: 'ContractApp',
  TRANSPORTSCREEN: 'TransportScreen',
  TRANSPORTAPP: 'TransportApp',
  TRANSPORTALLRATESCREEN: 'TransportAllRateScreen',
  TRANSPORTALLRATEAPP: 'TransportAllRateApp',
  UPLOADERSCREEN: "UploaderScreen",
  TRANSACTIONALSCREEN:"TransactionalScreen",
  TRANSACTIONALAPP:"TransactionalApp",
};
